module.exports = __webpack_public_path__ + "img/12_of_Spades.svg.e6a9cb45.png";